module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('keep-alive', [_c('mheader')], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('transition', [_c('keep-alive', [_c('sliderbar')], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    staticStyle: {
      "height": "calc(100% - 30px)",
      "margin-top": "15px",
      "padding": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eadd4ae2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Layout/Backend.vue
// module id = 623
// module chunks = 1